import { Grid, TWO_COLUMN_MAX_WIDTH } from '@spotify-internal/frodor-modules';
import React from 'react';
import styled from 'styled-components';
import { SideBar } from '../../legacy/blog/category/SideBar';
import { BlogPostPreview } from './BlogPostPreview';
import { useReduxBlog } from './useReduxBlog';

const CategoryItems = styled.div`
  grid-column: 1 / 9;
  display: flex;
  flex-direction: column;
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
  }
`;
const StyledSideBar = styled(SideBar)`
  grid-column: 9 / 12;
  position: sticky;
  top: 72px;
  margin-bottom: 110px;
  height: 100px;
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    display: none;
  }
`;

export const BlogSection = () => {
  const { blogPosts, blogCategories } = useReduxBlog();
  const categorySlug = 'all';
  const category = blogCategories?.bySlug[categorySlug];

  return (
    <div className="encore-light-set" style={{}}>
      <Grid>
        <CategoryItems>
          blog section coming soon
          {category.items.map((id: string) => {
            const post = blogPosts.byId[id];
            return <BlogPostPreview key={id} blogPost={post} />;
          })}
        </CategoryItems>
        <StyledSideBar />
      </Grid>
    </div>
  );
};
